import React, { useState, useEffect } from 'react';
import WebpackerReact from 'webpacker-react';
import HeaderTitle from '../GeneralComponents/HeaderTitle'
import Preloader from '../GeneralComponents/LoadingComponen';
import Swal from "sweetalert2/dist/sweetalert2.js";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Select from 'react-select';

const UserTenantIndex = (props) => {
    const token = document.querySelector("[name='csrf-token']").content;
    const [data, setData] = useState([]);
    const [isLoaded, setIsLoaded] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [userTenantId, setUserTenantId] = useState("");
    const [form, setForm] = useState({
        user_id: "",
        tenant_id: "",
        position_id: ""
    });
    const [selectedUser, setSelectedUser] = useState({
        value: "",
        label: "Seleccione el usuario"
    });
    const [selectedTenant, setSelectedTenant] = useState({
        value: "",
        label: "Seleccione el inquilino"
    });
    const [selectedPosition, setSelectedPosition] = useState({
        value: "",
        label: "Seleccione el cargo"
    });
    const [positionOptions, setPositionOptions] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [tenantOptions, setTenantOptions] = useState([]);

    useEffect(() => {
        console.log("useEffect 111111");
        loadData();
    }, []);

    useEffect(() => {
        // Procesar usuarios
        if (props.users) {
            const formattedUsers = props.users.map(user => ({
                value: user.id,
                label: `${user.first_name} ${user.first_last_name} (${user.username})`
            }));
            setUserOptions(formattedUsers);
        }

        // Procesar inquilinos
        if (props.tenants) {
            const formattedTenants = props.tenants.map(tenant => ({
                value: tenant.id,
                label: tenant.company_name,
                positions: tenant.positions // Mantener las posiciones para usar después
            }));
            setTenantOptions(formattedTenants);
        }
    }, [props.users, props.tenants]);

    const loadData = () => {
        console.log("Fetching data...");
        fetch("/settings/get_user_tenants", {
            method: 'GET',
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json"
            }
        })
            .then(response => {
                console.log("Response received:", response);
                return response.json();
            })
            .then(data => {
                console.log("Data processed:", data);
                setData(data.data);
                setIsLoaded(false);
            })
            .catch(error => {
                console.error("Error loading data:", error);
                setIsLoaded(false);
            });
    };

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const toggleForm = () => {
        setShowForm(!showForm);
        if (!showForm) {
            clearValues();
        }
    };

    const clearValues = () => {
        setUserTenantId("");
        setForm({
            user_id: "",
            tenant_id: "",
            position_id: ""
        });
        setSelectedUser({ value: "", label: "Seleccione el usuario" });
        setSelectedTenant({ value: "", label: "Seleccione el inquilino" });
        setSelectedPosition({ value: "", label: "Seleccione el cargo" });
        setPositionOptions([]);
    };

    const messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    const deleteUserTenant = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/settings/user_tenants/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        loadData()
                    });
            }
        });
    };

    const validationForm = () => {
        if (form.format_select_id != "" &&
            form.question_asociation_id != ""
        ) {
            return true
        } else {
            return false
        }
    }

    const handleClick = () => {
        if (true) {
            if (userTenantId) {
                fetch(`/settings/user_tenants/${userTenantId}`, {
                    method: 'PATCH',
                    body: JSON.stringify(form),
                    headers: {
                        "X-CSRF-Token": token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(res => res.json())
                    .then(data => {
                        updateItem(data.register);
                        messageSuccess(data);
                        setShowForm(false);
                        clearValues();
                    });
            } else {
                fetch(`/settings/user_tenants`, {
                    method: 'POST',
                    body: JSON.stringify(form),
                    headers: {
                        "X-CSRF-Token": token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(res => res.json())
                    .then(data => {
                        updateData(data.register)
                        messageSuccess(data);
                        setShowForm(false);
                        clearValues();
                    });
            }
        }
    }

    const edit = (userTenant) => {
        setShowForm(true);
        setUserTenantId(userTenant.id);
        setForm({
            user_id: userTenant.user_id,
            tenant_id: userTenant.tenant_id,
            position_id: userTenant.position_id
        });
        setSelectedUser({
            value: userTenant.user_id,
            label: userTenant.first_name + " " + userTenant.first_last_name + " (" + userTenant.username + ")"
        });
        setSelectedTenant({
            value: userTenant.tenant_id,
            label: userTenant.company_name
        });
        setSelectedPosition({
            value: userTenant.position_id,
            label: userTenant.name
        });
    }

    const updateData = (data) => {
        loadData();
    }

    const updateItem = (userTenant) => {
        loadData();
    }

    const handleChangeAutocomplete = selectedOption => {
        setSelectedUser(selectedOption);
        setForm({
            ...form,
            user_id: selectedOption.value
        });
    };

    const handleChangeCalendar = (e) => {
        let date = new Date(e)
        let date_month = ("0" + (date.getMonth() + 1)).slice(-2)
        let day = ("0" + (date.getDate())).slice(-2)
        let new_date = `${date.getFullYear()}-${date_month}-${day}`
        let array = form.days
        //año-mes-dia
        if (true) {
            array.push(new_date)
        }

        setForm({
            ...form,
            days: array
        })
    }

    const removeArray = (index) => {
        var arr = form.days
        delete arr[index]
        setForm({
            ...form,
            days: arr.filter(item => item != null)
        })
    }

    const removeAll = () => {
        setForm({
            ...form,
            days: []
        })
    }

    return (
        <React.Fragment>
            <HeaderTitle
                title={`Gestión de Usuarios por Inquilino`}
                subTitle={"Administra los usuarios y sus roles"}
                titleNew={showForm ? "Cancelar" : "Nuevo"}
                titleFilter={"Filtros"}
                icon="fas fa-users"
                onClickNew={toggleForm}
                showNew={true}
                showFilter={false}
            />

            {showForm && (
                <div className="content main-card mb-3 card">
                    <div className="card-body">
                        <h5 className="card-title">{userTenantId ? "Actualizar usuario" : "Crear usuario"}</h5>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Usuario</label>
                                    <Select
                                        value={selectedUser}
                                        onChange={handleChangeAutocomplete}
                                        options={userOptions}
                                        placeholder="Seleccione el usuario"
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Inquilino</label>
                                    <Select
                                        value={selectedTenant}
                                        onChange={(option) => {
                                            setSelectedTenant(option);
                                            setForm({ ...form, tenant_id: option.value });
                                            const selectedTenantData = tenantOptions.find(tenant => tenant.value === option.value);
                                            const positions = selectedTenantData ? selectedTenantData.positions.map(pos => ({
                                                value: pos.id,
                                                label: pos.name
                                            })) : [];
                                            setPositionOptions(positions);
                                            setSelectedPosition({ value: "", label: "Seleccione el cargo" });
                                            setForm(prev => ({ ...prev, position_id: "" }));
                                        }}
                                        options={tenantOptions}
                                        placeholder="Seleccione el inquilino"
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Cargo</label>
                                    <Select
                                        value={selectedPosition}
                                        onChange={(option) => {
                                            setSelectedPosition(option);
                                            setForm({ ...form, position_id: option.value });
                                        }}
                                        options={positionOptions}
                                        placeholder="Seleccione el cargo"
                                        isDisabled={!selectedTenant.value}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="text-right">
                            <button
                                className="btn btn-primary"
                                onClick={handleClick}
                            >
                                {userTenantId ? "Actualizar" : "Guardar"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {!isLoaded ? (
                <React.Fragment>
                    <div className="content main-card mb-3 card">
                        <div className="card-body">
                            <table className="table table-hover table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th width="50px">Item</th>
                                        <th>Usuario</th>
                                        <th>Inquilino</th>
                                        <th>Cargo</th>
                                        <th style={{ width: "4%" }}>Acciones</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {data.length >= 1 ? (
                                        data.map((userTenant, index) => (
                                            <tr key={userTenant.id}>
                                                <td>{index + 1}</td>
                                                <td>{userTenant.user_name}</td>
                                                <td>{userTenant.tenant_name}</td>
                                                <td>{userTenant.position_name}</td>
                                                <td className="text-right">
                                                    {true && (
                                                        <UncontrolledDropdown className='btn-group'>
                                                            <DropdownToggle className='btn-shadow btn btn-info'>
                                                                <i className="fas fa-bars"></i>
                                                            </DropdownToggle>
                                                            <DropdownMenu className="dropdown-menu dropdown-menu-right">


                                                                {true && (
                                                                    <DropdownItem
                                                                        onClick={() => deleteUserTenant(userTenant.id)}
                                                                        className="dropdown-item"
                                                                    >
                                                                        Eliminar
                                                                    </DropdownItem>
                                                                )}
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                <div className="text-center mt-4 mb-4">
                                                    <h4>No hay registros</h4>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </React.Fragment>
            ) : (
                <Preloader />
            )}
        </React.Fragment>
    );
};

export default UserTenantIndex;
WebpackerReact.setup({ UserTenantIndex });

